import { Form } from "react-bootstrap";
import { getProductInfo } from "src/utils/storage/product";
import { PRICE_LIST, PriceListType } from "src/config/priceTypeList";
import "./SitePay.style.scss";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import CommonFormProvider from "src/context/Modal/Form/CommonForm.provider";
import RightDetailBox from "./RightDetailBoxNew";
import { SetStateAction } from "react";
import { useFormContext } from "react-hook-form";
import ConfirmPolicy from "../Common/Form/FormItem/ConfirmPolicy";
import SelectPayType from "../Common/Form/FormItem/SelectPayType";
import PayTerm from "../Common/Form/FormItem/PayTerm";
import CompanyName from "../Common/Form/FormItem/CompanyName";
import LicenseCount from "../Common/Form/FormItem/LicenseCount";
import { useTranslation } from "react-i18next";

interface ISitePayUIProps {
  userPerPrice: number;
  userPerPriceYear: number;
  currency: string;
  payCompany: string;
  isInit: boolean;
  isShowPay: boolean;
  planId: string; // paypal
  isRenew: boolean;
  startDate: string;
  inicisData: any;
  selectAppList: string[];
  setSelectAppList: React.Dispatch<SetStateAction<string[]>>;
  showTaxInvoiceFields: boolean;
  toggleTaxInvoidFields: () => void;
  taxInvoiceInfo: any;
  handleChangeTaxInvoice: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeTaxRequestDate: (date: Date | null) => void;
}

const SitePayUI = ({
  userPerPrice,
  userPerPriceYear,
  currency,
  isInit,
  isShowPay,
  isRenew,
  inicisData,
  payCompany,
  startDate,
  planId,
  showTaxInvoiceFields,
  toggleTaxInvoidFields,
  taxInvoiceInfo,
  handleChangeTaxInvoice,
  handleChangeTaxRequestDate,
  selectAppList,
  setSelectAppList,
}: ISitePayUIProps) => {
  const { watch } = useFormContext();
  const priceType = watch("priceType");
  const { t } = useTranslation();
  const productInfo =
    PRICE_LIST({ t })[getProductInfo().key].filter(
      (item: PriceListType) => item.key === priceType
    ).length > 0
      ? PRICE_LIST({ t })[getProductInfo().key].filter(
        (item: PriceListType) => item.key === priceType
      )[0]
      : { key: "", name: "", featuresCnt: 0, upcCnt: -1 };
  const productName = getProductInfo().name;

  return (
    <CommonFormProvider>
      <div className="containerBox">
        <div className="container">
          {!isShowPay ? (
            <div className="site">
              <h3 className="site__title">
                {productName + " Cloud " + productInfo.name}
              </h3>
              <p className="site__desc">
                {priceType &&
                  priceType !== "" &&
                  getProductFromSessionStorage() === "WRAPSODY"
                  ? t(`siteType.subTitle`, { 0: priceType as string })
                  : ""}
              </p>
              <div className="flex justify-space-between">
                <div className="flex-item box box__lt bg-white">
                  <Form className="form">
                    <h4 className="form-title">
                      {t("siteType.basic.detail.plan.title")}
                    </h4>

                    {/* 사용자 수 */}
                    <LicenseCount isRenew={isRenew} />
                    {/* 회사 이름 */}
                    <CompanyName />
                    {/* 결제 주기 */}
                    <PayTerm
                      currency={currency}
                      priceType={priceType}
                      userPerPrice={userPerPrice}
                      userPerPriceYear={userPerPriceYear}
                    />
                    {/* 결제 정보 */}
                    <SelectPayType currency={currency} priceType={priceType} />
                    {/* 통합 이용약관, 개인정보처리방침 */}
                    <ConfirmPolicy />
                  </Form>
                </div>
                <RightDetailBox
                  payCompany={payCompany}
                  userPerPriceYear={userPerPriceYear}
                  userPerPrice={userPerPrice}
                  currency={currency}
                  inicisData={inicisData}
                  startDate={startDate}
                  planId={planId}
                  showTaxInvoiceFields={showTaxInvoiceFields}
                  toggleTaxInvoidFields={toggleTaxInvoidFields}
                  taxInvoiceInfo={taxInvoiceInfo}
                  handleChangeTaxInvoice={handleChangeTaxInvoice}
                  handleChangeTaxRequestDate={handleChangeTaxRequestDate}
                  selectAppList={selectAppList}
                  setSelectAppList={setSelectAppList}
                />
              </div>
            </div>
          ) : isInit ? (
            ""
          ) : (
            ""
          )}
        </div>
      </div>
    </CommonFormProvider>
  );
};

export default SitePayUI;
